//
// Module for the DRO Setup wizard's Allocation (with a source benefit selected) step
//
rs.module("participant/benefit/setup/dro/wizard/sourcebenefitallocationstep",

    [],

    function () {

        // Initialize the module
        function initialize() {

            // Get the wizard buttons
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // On initialize of page, we're going somewhere, just don't know where necessarily
            setWizardNextButtonText();

            // set display of Wizard's next button text to Next
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);